"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./browser/index'));
//# sourceMappingURL=browser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-universal/browser.js
// module id = 410
// module chunks = 0